// Users.js
import React, { Component } from "react";
import AdmissionApi from "../../../Services/AdmissionApi";
import Paging from "../../Paging";
import "./style.css";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      selectedUser: '',
      page: 1,
      pageSize: 6,
      totalPages: 1
    }

    this.admissionsService = new AdmissionApi();
  }

  UNSAFE_componentWillMount() {
    this.getData();
  }

  updateState = (response) => {
    this.setState({
      users: response.data._embedded.users,
      page: response.data.page,
      totalPages: response.data.pageCount
    })
  }

  getData = (page = 1) => {
    let filters = ''
    const {
      selectedUser,
      pageSize
    } = this.state

    if (selectedUser) filters += `&text=${selectedUser}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/users?page=${page}&pageSize=${pageSize}${filters}`
    )
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getData()
  }

  clearFilter = () => {
    this.setState({
      selectedUser: ''
    }, this.getData)
  }

  handlePageChange = (page) => {
    this.getData(page)
  }

  render() {
    const {
      users,
      page,
      totalPages,
      selectedUser
    } = this.state;
    const { showDetails, updateRoutePage } = this.props;

    return (
      <section className="dash-alerts">
        <form>
          <div className="alert-filter" style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <input
              id="selectedUser"
              type="text"
              className="form-control alert-filter__input mr-2"
              placeholder="User Name"
              value={selectedUser}
              onChange={this.handleFilterInputChange}
            />
            <button type="submit" onClick={this.filterList} className="btn btn--primary">
              Submit
            </button>

            <button type="button" onClick={this.clearFilter} className="btn btn--default ml-2">
              Clear
            </button>
            <button type="button" onClick={() => updateRoutePage('user-form')} className='btn btn--new ml-2'>
              <i className="icon-plus" />
            </button>
          </div>
        </form>

        <table className="table table-responsive alert-table">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Username</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Gender</th>
              <th scope="col">Date of birth</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {users.map(item => (
              <tr key={item.id}>
                <td>{item.first_name} {item.last_name}</td>
                <td>{item.user_name}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.gender}</td>
                <td>{item.date_of_birth ? (new Date(item.date_of_birth)).toLocaleDateString('en-GB') : '-'}</td>

                <td className="d-flex">
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('user-form', item)}>
                    <i className="icon-pencil" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Paging
          page={page}
          totalPages={totalPages}
          onChange={this.handlePageChange}
        />
      </section>
    )
  }
}

export default Users;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Users/index.js
 **/